import { getSearchedResources } from 'legacy/src/queries';

const getResources = async ({
  unitsClient: client,
  subjectId,
  resourceTypes,
  searchTerm,
  educationPeriod,
  sortOrder,
  resourceSubType,
}) => {
  let response;
  try {
    response = await client.query({
      query: getSearchedResources,
      variables: {
        subjectId,
        resourceTypes,
        resourceSubType,
        searchTerm: searchTerm || '',
        educationPeriod,
        sortOrder,
      },
    });
  } catch (error) {
    //No need to catch the error
  }
  let resources;
  if (response) {
    ({ filteredResources: resources } = (response && response.data) || {});
  } else {
    resources = [];
  }

  return resources;
};

export default getResources;
